// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"BreadCrumb_wrapper__yNOJd","breadcrumb":"BreadCrumb_breadcrumb__AtLHK"};